// extracted by mini-css-extract-plugin
export default {"sigContainer":"styles_sigContainer__XsvrV","sigPad":"styles_sigPad__ss847","signButtons":"styles_signButtons__+FjlX","sigImage":"styles_sigImage__Dow7v"};